<template>
    <inertia-head :title="metaTitle">
       <slot/>
    </inertia-head>
</template>

<script>
export default {
    props: ['title'],

    computed: {
        metaTitle(){
            let title = '';
            if(this.title){
                title = this.title+' | ';
            }
            return title+this.$page.props.metaTitle;
        }
    }
}
</script>